import React, { useState, useMemo, useRef, useEffect } from 'react';
import {
  ChevronLeft,
  Search,
  Calendar,
  Printer,
  Plus,
  MoreVertical,
  Send,
  Image as ImageIcon,
  CheckCircle2,
  X,
  FileText,
  User,
  MessageSquare,
  Paperclip,
  Clock,
  Building,
  Check,
} from 'lucide-react';

export interface ChatMessage {
  id: string;
  sender: 'admin' | 'resident';
  senderName: string;
  message?: string;
  imageUrl?: string;
  timestamp: string; // e.g. 19/03/2024 - 18:33 น.
}

export interface PastComplaint {
  id: string;
  date: string; // e.g. 24/05/2023 - 13:32 น.
  title: string; // e.g. Yyyyyyy
  details?: string;
  imageUrl?: string;
  status?: 'completed' | 'active';
}

export interface ComplaintRecord {
  id: string;
  unitNo: string; // e.g. 1086/20
  residentName: string; // e.g. Silverman support or tobb555 satob
  avatarUrl?: string;
  isOfficialSupport?: boolean;
  title: string; // e.g. 1234
  date: string; // e.g. 19/03/2024 - 18:37 น.
  rawDate: string; // YYYY-MM-DD
  status: 'active' | 'completed'; // active = คำร้อง, completed = เสร็จสิ้นแล้ว
  cancelNoticeTitle?: string; // e.g. หัวข้อ1 (if canceled/notice)
  cancelNoticeText?: string; // e.g. ยกเลิก
  activeTicket: {
    date: string; // e.g. 15/03/2024 - 15:56 น.
    title: string; // e.g. 1234
    details: string; // e.g. 12348641568778645687
    imageUrl?: string;
  };
  messages: ChatMessage[];
  pastComplaints: PastComplaint[];
}

const INITIAL_COMPLAINTS: ComplaintRecord[] = [
  {
    id: 'comp-1',
    unitNo: '1086/20',
    residentName: 'Silverman support',
    isOfficialSupport: true,
    title: '1234',
    date: '19/03/2024 - 18:37 น.',
    rawDate: '2024-03-19',
    status: 'active',
    activeTicket: {
      date: '15/03/2024 - 15:56 น.',
      title: '1234',
      details: '12348641568778645687',
    },
    messages: [
      {
        id: 'msg-1',
        sender: 'admin',
        senderName: 'Silverman support',
        message: 'กหดหกด',
        timestamp: '19/03/2024 - 18:33 น.',
      },
      {
        id: 'msg-2',
        sender: 'admin',
        senderName: 'Silverman support',
        message: 'หกดกหดกหด',
        timestamp: '19/03/2024 - 18:34 น.',
      },
      {
        id: 'msg-3',
        sender: 'admin',
        senderName: 'Silverman support',
        message: 'หฟ่าจำพะพ่าะ',
        timestamp: '19/03/2024 - 18:34 น.',
      },
      {
        id: 'msg-4',
        sender: 'admin',
        senderName: 'Silverman support',
        message: 'eee',
        timestamp: '19/03/2024 - 18:35 น.',
      },
      {
        id: 'msg-5',
        sender: 'admin',
        senderName: 'Silverman support',
        message: 'wrwer',
        timestamp: '19/03/2024 - 18:37 น.',
      },
      {
        id: 'msg-6',
        sender: 'admin',
        senderName: 'Silverman support',
        message: 'wretet',
        timestamp: '19/03/2024 - 18:37 น.',
      },
    ],
    pastComplaints: [
      {
        id: 'past-1',
        date: '24/05/2023 - 13:32 น.',
        title: 'Yyyyyyy',
        details: 'สอบถามกำหนดการล้างสระว่ายน้ำส่วนกลาง',
        status: 'completed',
      },
      {
        id: 'past-2',
        date: '28/05/2023 - 13:30 น.',
        title: 'เสียงดัง',
        details: 'มีเสียงรบกวนช่วงเวลากลางคืน',
        status: 'completed',
      },
      {
        id: 'past-3',
        date: '12/01/2023 - 10:15 น.',
        title: 'หัวข้อ1',
        details: 'แจ้งไฟทางเดินดับ',
        status: 'completed',
      },
    ],
  },
  {
    id: 'comp-2',
    unitNo: '1086/20',
    residentName: 'Silverman support',
    isOfficialSupport: true,
    title: '123456456123',
    date: '15/03/2024 - 16:19 น.',
    rawDate: '2024-03-15',
    status: 'active',
    activeTicket: {
      date: '15/03/2024 - 16:19 น.',
      title: '123456456123',
      details: 'สอบถามรายละเอียดการเข้าใช้บริการห้องฟิตเนสและช่วงเวลาเปิด-ปิด',
    },
    messages: [
      {
        id: 'msg-2-1',
        sender: 'admin',
        senderName: 'Silverman support',
        message: 'ได้รับเรื่องแล้ว กำลังตรวจสอบระเบียบการใช้พื้นที่ให้ครับ',
        timestamp: '15/03/2024 - 16:20 น.',
      },
    ],
    pastComplaints: [
      {
        id: 'past-2-1',
        date: '24/05/2023 - 13:32 น.',
        title: 'หัวข้อ1',
        details: 'ขอบคุณทีมงาน',
        status: 'completed',
      },
      {
        id: 'past-2-2',
        date: '28/05/2023 - 13:30 น.',
        title: 'เสียงดัง',
        details: 'เรียบร้อยแล้ว',
        status: 'completed',
      },
    ],
  },
  {
    id: 'comp-3',
    unitNo: '1086/16',
    residentName: 'tobb555 satob',
    avatarUrl:
      'https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=100&auto=format&fit=crop&q=80',
    title: 'Test',
    date: '05/03/2024 - 11:42 น.',
    rawDate: '2024-03-05',
    status: 'active',
    cancelNoticeTitle: 'หัวข้อ1',
    cancelNoticeText: 'ยกเลิก',
    activeTicket: {
      date: '04/06/2023 - 16:08 น.',
      title: 'หัวข้อ1',
      details: 'หัวข้อ1',
      imageUrl:
        'https://images.unsplash.com/photo-1517685352821-92cf88aee5a5?w=500&auto=format&fit=crop&q=80',
    },
    messages: [
      {
        id: 'msg-3-1',
        sender: 'resident',
        senderName: 'tobb555 satob',
        message: 'ข้อความ',
        timestamp: '04/06/2023 - 16:10 น.',
      },
      {
        id: 'msg-3-2',
        sender: 'resident',
        senderName: 'tobb555 satob',
        imageUrl:
          'https://images.unsplash.com/photo-1517685352821-92cf88aee5a5?w=500&auto=format&fit=crop&q=80',
        timestamp: '04/06/2023 - 16:10 น.',
      },
    ],
    pastComplaints: [
      {
        id: 'past-3-1',
        date: '15/03/2024 - 12:15 น.',
        title: 'แมว',
        details: 'พบแมวจรจัดแถวที่จอดรถอาคาร B',
        status: 'completed',
      },
      {
        id: 'past-3-2',
        date: '04/08/2023 - 14:45 น.',
        title: 'ที่จอดรถซ้อนคัน',
        details: 'มีรถจอดซ้อนคันไม่ปลดเกียร์ว่าง',
        status: 'completed',
      },
    ],
  },
  {
    id: 'comp-4',
    unitNo: '1086/02',
    residentName: 'คุณพัชราภา',
    title: 'น้ำรั่วซึมท่อทางเดินส่วนกลาง',
    date: '28/02/2024 - 09:15 น.',
    rawDate: '2024-02-28',
    status: 'completed',
    activeTicket: {
      date: '28/02/2024 - 09:15 น.',
      title: 'น้ำรั่วซึมท่อทางเดินส่วนกลาง',
      details: 'เจ้าหน้าที่เข้าเปลี่ยนข้อต่อท่อระบายน้ำชั้น 3 เรียบร้อยแล้ว',
    },
    messages: [
      {
        id: 'msg-4-1',
        sender: 'admin',
        senderName: 'ช่างอาคาร',
        message: 'ซ่อมแซมและเช็ดทำความสะอาดพื้นที่เรียบร้อยแล้วครับ',
        timestamp: '28/02/2024 - 15:30 น.',
      },
    ],
    pastComplaints: [],
  },
  {
    id: 'comp-5',
    unitNo: '1086/08',
    residentName: 'Rose (คุณธนกฤต)',
    title: 'ขอตัดแต่งกิ่งไม้หน้าบ้าน',
    date: '25/02/2024 - 14:20 น.',
    rawDate: '2024-02-25',
    status: 'completed',
    activeTicket: {
      date: '25/02/2024 - 14:20 น.',
      title: 'ขอตัดแต่งกิ่งไม้หน้าบ้าน',
      details: 'ทีมสวนเข้าดำเนินการตัดแต่งกิ่งไม้เรียบร้อย',
    },
    messages: [],
    pastComplaints: [],
  },
];

interface Props {
  onBackToMenu: () => void;
}

export const AdminComplaintsManagementView: React.FC<Props> = ({ onBackToMenu }) => {
  // State: List of complaints
  const [complaints, setComplaints] = useState<ComplaintRecord[]>(INITIAL_COMPLAINTS);

  // Active Tab: 'active' (คำร้อง) | 'completed' (เสร็จสิ้นแล้ว)
  const [activeTab, setActiveTab] = useState<'active' | 'completed'>('active');

  // Currently opened complaint detail id (null means in list view)
  const [selectedComplaintId, setSelectedComplaintId] = useState<string | null>(null);

  // Date filters
  const [startDate, setStartDate] = useState('2024-02-29');
  const [endDate, setEndDate] = useState('2024-03-29');
  const [searchQuery, setSearchQuery] = useState('');

  // Chat message input in Detail view
  const [chatInput, setChatInput] = useState('');
  const [pendingImageUrl, setPendingImageUrl] = useState<string | null>(null);
  const chatMessagesEndRef = useRef<HTMLDivElement>(null);

  // 3-dots action menu state on active card
  const [showCardMenu, setShowCardMenu] = useState(false);

  // Modal: New Direct Message / Complaint to Resident
  const [showNewMessageModal, setShowNewMessageModal] = useState(false);
  const [newMsgUnit, setNewMsgUnit] = useState('1086/20');
  const [newMsgRecipient, setNewMsgRecipient] = useState('Silverman support');
  const [newMsgTitle, setNewMsgTitle] = useState('');
  const [newMsgBody, setNewMsgBody] = useState('');
  const [newMsgImage, setNewMsgImage] = useState<string | null>(null);

  // Get currently selected complaint object
  const selectedComplaint = useMemo(() => {
    return complaints.find((c) => c.id === selectedComplaintId) || null;
  }, [complaints, selectedComplaintId]);

  // Filtered complaints based on Tab, Date range, and Search Query
  const filteredComplaints = useMemo(() => {
    return complaints.filter((item) => {
      if (item.status !== activeTab) return false;

      if (startDate && item.rawDate && item.rawDate < startDate) return false;
      if (endDate && item.rawDate && item.rawDate > endDate) return false;

      if (searchQuery.trim()) {
        const q = searchQuery.toLowerCase().trim();
        const match =
          item.unitNo.toLowerCase().includes(q) ||
          item.residentName.toLowerCase().includes(q) ||
          item.title.toLowerCase().includes(q) ||
          item.activeTicket.details.toLowerCase().includes(q);
        if (!match) return false;
      }

      return true;
    });
  }, [complaints, activeTab, startDate, endDate, searchQuery]);

  // Scroll to bottom when messages update
  useEffect(() => {
    if (selectedComplaintId && chatMessagesEndRef.current) {
      chatMessagesEndRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  }, [selectedComplaintId, selectedComplaint?.messages.length]);

  // HANDLER: Send chat message
  const handleSendMessage = (e?: React.FormEvent) => {
    if (e) e.preventDefault();
    if (!selectedComplaintId) return;
    if (!chatInput.trim() && !pendingImageUrl) return;

    const now = new Date();
    const formattedTime = `${now.getDate().toString().padStart(2, '0')}/${(now.getMonth() + 1)
      .toString()
      .padStart(2, '0')}/${now.getFullYear() + 543} - ${now
      .getHours()
      .toString()
      .padStart(2, '0')}:${now.getMinutes().toString().padStart(2, '0')} น.`;

    const newChatMessage: ChatMessage = {
      id: `msg-${Date.now()}`,
      sender: 'admin',
      senderName: 'Silverman support',
      message: chatInput.trim() || undefined,
      imageUrl: pendingImageUrl || undefined,
      timestamp: formattedTime,
    };

    setComplaints((prev) =>
      prev.map((c) => {
        if (c.id === selectedComplaintId) {
          return {
            ...c,
            messages: [...c.messages, newChatMessage],
          };
        }
        return c;
      })
    );

    setChatInput('');
    setPendingImageUrl(null);
  };

  // HANDLER: Mark complaint as completed (ดำเนินการเสร็จสิ้น)
  const handleMarkAsCompleted = () => {
    if (!selectedComplaintId) return;
    setComplaints((prev) =>
      prev.map((c) => {
        if (c.id === selectedComplaintId) {
          return {
            ...c,
            status: 'completed',
          };
        }
        return c;
      })
    );
    setShowCardMenu(false);
  };

  // HANDLER: Create new message / ticket
  const handleCreateNewMessage = (e: React.FormEvent) => {
    e.preventDefault();
    if (!newMsgTitle.trim() || !newMsgBody.trim()) {
      alert('กรุณากรอกหัวข้อและรายละเอียดข้อความ');
      return;
    }

    const now = new Date();
    const formattedDate = `${now.getDate().toString().padStart(2, '0')}/${(now.getMonth() + 1)
      .toString()
      .padStart(2, '0')}/${now.getFullYear() + 543} - ${now
      .getHours()
      .toString()
      .padStart(2, '0')}:${now.getMinutes().toString().padStart(2, '0')} น.`;
    const yyyymmdd = now.toISOString().split('T')[0];

    const newRecord: ComplaintRecord = {
      id: `comp-${Date.now()}`,
      unitNo: newMsgUnit,
      residentName: newMsgRecipient,
      isOfficialSupport: newMsgRecipient.includes('Silverman'),
      title: newMsgTitle,
      date: formattedDate,
      rawDate: yyyymmdd,
      status: 'active',
      activeTicket: {
        date: formattedDate,
        title: newMsgTitle,
        details: newMsgBody,
        imageUrl: newMsgImage || undefined,
      },
      messages: [
        {
          id: `msg-${Date.now()}-init`,
          sender: 'admin',
          senderName: 'Silverman support',
          message: newMsgBody,
          imageUrl: newMsgImage || undefined,
          timestamp: formattedDate,
        },
      ],
      pastComplaints: [],
    };

    setComplaints((prev) => [newRecord, ...prev]);
    setShowNewMessageModal(false);
    setNewMsgTitle('');
    setNewMsgBody('');
    setNewMsgImage(null);
    setSelectedComplaintId(newRecord.id);
  };

  return (
    <div className="bg-white rounded-2xl border border-slate-200 shadow-2xs min-h-[85vh] flex flex-col font-sans text-slate-800">
      {/* ========================================================================= */}
      {/* 1. DETAIL / CHAT VIEW (Images 4, 5, 6, 7) */}
      {/* ========================================================================= */}
      {selectedComplaint ? (
        <div className="flex flex-col flex-1 min-h-[750px] bg-white">
          {/* Top Bar Header matching Images 4, 5, 6 */}
          <div className="px-5 py-3.5 border-b border-slate-100 flex items-center justify-between bg-white">
            <div className="flex items-center gap-3">
              <button
                type="button"
                onClick={() => {
                  setSelectedComplaintId(null);
                  setShowCardMenu(false);
                }}
                className="w-8 h-8 rounded-full border border-slate-300 hover:bg-slate-100 flex items-center justify-center text-slate-600 transition-colors cursor-pointer"
                title="กลับสู่กล่องข้อความ"
              >
                <ChevronLeft className="w-5 h-5" />
              </button>

              {/* Avatar & User Name */}
              <div className="flex items-center gap-2.5">
                {selectedComplaint.avatarUrl ? (
                  <img
                    src={selectedComplaint.avatarUrl}
                    alt={selectedComplaint.residentName}
                    className="w-8 h-8 rounded-full object-cover border border-slate-200"
                  />
                ) : selectedComplaint.isOfficialSupport ? (
                  <div className="w-8 h-8 bg-slate-900 rounded-md flex items-center justify-center text-white text-[11px] font-black tracking-tighter shadow-2xs">
                    <span className="text-[10px]">👔</span>
                  </div>
                ) : (
                  <div className="w-8 h-8 bg-blue-100 text-blue-700 rounded-full flex items-center justify-center font-bold text-xs">
                    {selectedComplaint.residentName.charAt(0)}
                  </div>
                )}

                <div>
                  <h2 className="text-sm font-bold text-slate-900 flex items-center gap-2">
                    {selectedComplaint.residentName}
                    {selectedComplaint.status === 'completed' && (
                      <span className="text-[10px] font-semibold px-2 py-0.5 rounded-full bg-emerald-100 text-emerald-800 border border-emerald-200">
                        เสร็จสิ้นแล้ว
                      </span>
                    )}
                  </h2>
                  <span className="text-[11px] text-slate-400 font-mono">
                    {selectedComplaint.unitNo}
                  </span>
                </div>
              </div>
            </div>
          </div>

          {/* Main Content Split: Chat Stream (Left 65%) vs Sidebar (Right 35%) */}
          <div className="flex-1 flex flex-col lg:flex-row overflow-hidden min-h-[600px]">
            {/* ----------------- LEFT: CHAT AREA ----------------- */}
            <div className="flex-1 flex flex-col justify-between border-r border-slate-100 bg-white">
              {/* Chat Message Scrollable View */}
              <div className="flex-1 p-6 overflow-y-auto space-y-4 max-h-[560px]">
                {/* Notice Card if Canceled (Image 6) */}
                {selectedComplaint.cancelNoticeText && (
                  <div className="max-w-md mx-auto my-4 p-4 border border-slate-200 rounded-lg bg-white shadow-2xs text-center space-y-1">
                    <span className="text-xs font-bold text-slate-800 block">
                      {selectedComplaint.cancelNoticeText}
                    </span>
                    <span className="text-xs text-slate-600 block">
                      {selectedComplaint.cancelNoticeTitle}
                    </span>
                  </div>
                )}

                {/* Message Bubbles */}
                {selectedComplaint.messages.length === 0 ? (
                  <div className="h-full flex flex-col items-center justify-center text-slate-400 text-xs py-16">
                    <MessageSquare className="w-8 h-8 mb-2 stroke-1 text-slate-300" />
                    <span>ยังไม่มีบทสนทนา พิมพ์ข้อความด้านล่างเพื่อเริ่มการติดต่อ</span>
                  </div>
                ) : (
                  selectedComplaint.messages.map((msg) => (
                    <div
                      key={msg.id}
                      className={`flex flex-col ${
                        msg.sender === 'admin' ? 'items-end' : 'items-end'
                      } space-y-1`}
                    >
                      {/* Text Bubble (Light blue background matching Image 4/5) */}
                      {msg.message && (
                        <div className="bg-sky-100 text-slate-800 text-xs px-4 py-2.5 rounded-sm max-w-sm font-sans break-words shadow-2xs">
                          {msg.message}
                        </div>
                      )}

                      {/* Image Message (Image 6) */}
                      {msg.imageUrl && (
                        <div className="p-1 border border-slate-200 rounded bg-sky-50 max-w-xs overflow-hidden shadow-2xs">
                          <img
                            src={msg.imageUrl}
                            alt="Attachment"
                            className="w-full max-h-60 object-cover rounded"
                          />
                        </div>
                      )}

                      {/* Timestamp underneath */}
                      <span className="text-[10px] text-slate-400 font-sans tracking-tight">
                        {msg.timestamp}
                      </span>
                    </div>
                  ))
                )}
                <div ref={chatMessagesEndRef} />
              </div>

              {/* Pending image preview before send */}
              {pendingImageUrl && (
                <div className="px-6 py-2 bg-slate-50 border-t border-slate-200 flex items-center gap-3">
                  <div className="relative w-12 h-12 rounded border border-slate-300 overflow-hidden">
                    <img
                      src={pendingImageUrl}
                      alt="Pending"
                      className="w-full h-full object-cover"
                    />
                    <button
                      type="button"
                      onClick={() => setPendingImageUrl(null)}
                      className="absolute top-0 right-0 bg-rose-600 text-white rounded-bl p-0.5"
                    >
                      <X className="w-3 h-3" />
                    </button>
                  </div>
                  <span className="text-xs text-slate-600">แนบรูปภาพพร้อมส่ง</span>
                </div>
              )}

              {/* Bottom Chat Input Bar matching Images 4, 5 */}
              <form
                onSubmit={handleSendMessage}
                className="p-4 border-t border-slate-100 flex items-center gap-3 bg-white"
              >
                {/* Image Upload Button */}
                <label className="p-2 text-slate-400 hover:text-slate-600 hover:bg-slate-100 rounded-lg cursor-pointer transition-colors">
                  <ImageIcon className="w-5 h-5" />
                  <input
                    type="file"
                    accept="image/*"
                    className="hidden"
                    onChange={(e) => {
                      const file = e.target.files?.[0];
                      if (file) {
                        setPendingImageUrl(URL.createObjectURL(file));
                      }
                    }}
                  />
                </label>

                {/* Input Text Box */}
                <input
                  type="text"
                  placeholder="พิมพ์ข้อความของคุณ"
                  value={chatInput}
                  onChange={(e) => setChatInput(e.target.value)}
                  className="flex-1 px-4 py-2 text-xs border-none focus:outline-none placeholder:text-slate-400 text-slate-800"
                />

                {/* Blue SEND Button */}
                <button
                  type="submit"
                  className="px-6 py-2 bg-sky-500 hover:bg-sky-600 text-white text-xs font-bold rounded-sm shadow-xs transition-colors cursor-pointer"
                >
                  ส่ง
                </button>
              </form>
            </div>

            {/* ----------------- RIGHT: SIDEBAR AREA ----------------- */}
            <div className="w-full lg:w-80 p-5 space-y-6 bg-white overflow-y-auto">
              {/* 1. Active Complaint Card (Top with ⋮ menu) */}
              <div className="border border-slate-200 rounded-lg p-4 bg-white shadow-2xs space-y-3 relative">
                {/* 3-dots Menu Button */}
                <div className="absolute top-3 right-3">
                  <button
                    type="button"
                    onClick={() => setShowCardMenu(!showCardMenu)}
                    className="p-1 text-slate-400 hover:text-slate-600 hover:bg-slate-100 rounded cursor-pointer transition-colors"
                  >
                    <MoreVertical className="w-4 h-4" />
                  </button>

                  {/* Popover Dropdown matching Image 7: "ดำเนินการเสร็จสิ้น" */}
                  {showCardMenu && (
                    <div className="absolute right-0 top-7 w-40 bg-white border border-slate-200 rounded-md shadow-lg py-1 z-30 font-sans">
                      <button
                        type="button"
                        onClick={handleMarkAsCompleted}
                        className="w-full text-left px-3 py-2 text-xs text-slate-700 hover:bg-slate-100 flex items-center gap-2 cursor-pointer font-medium"
                      >
                        <Check className="w-3.5 h-3.5 text-emerald-600" />
                        ดำเนินการเสร็จสิ้น
                      </button>
                    </div>
                  )}
                </div>

                {/* Date Header */}
                <span className="text-[11px] text-slate-400 block">
                  {selectedComplaint.activeTicket.date}
                </span>

                {/* Title */}
                <h3 className="text-sm font-bold text-slate-900 leading-snug">
                  {selectedComplaint.activeTicket.title}
                </h3>

                {/* Details */}
                <p className="text-xs text-slate-700 leading-relaxed break-words">
                  {selectedComplaint.activeTicket.details}
                </p>

                {/* Image attachment if exists (Image 6) */}
                {selectedComplaint.activeTicket.imageUrl && (
                  <div className="pt-2">
                    <img
                      src={selectedComplaint.activeTicket.imageUrl}
                      alt="Ticket Attachment"
                      className="w-full max-h-48 object-cover rounded border border-slate-200 shadow-2xs"
                    />
                  </div>
                )}
              </div>

              {/* 2. Past Complaints Section ("ร้องเรียนที่ผ่านมา") */}
              <div className="space-y-3">
                <h4 className="text-xs font-bold text-slate-800">ร้องเรียนที่ผ่านมา</h4>

                <div className="space-y-3">
                  {selectedComplaint.pastComplaints.length === 0 ? (
                    <div className="border border-slate-100 rounded-lg p-3 text-center text-[11px] text-slate-400 bg-slate-50/50">
                      ไม่มีประวัติการร้องเรียนก่อนหน้า
                    </div>
                  ) : (
                    selectedComplaint.pastComplaints.map((past) => (
                      <div
                        key={past.id}
                        className="border border-slate-200 rounded-lg p-3.5 bg-white shadow-2xs space-y-1.5 hover:border-blue-300 transition-colors"
                      >
                        <span className="text-[11px] text-slate-400 block">{past.date}</span>
                        {/* Blue clickable title matching Image 5 */}
                        <button
                          type="button"
                          onClick={() => {
                            if (past.details) {
                              alert(`รายละเอียด: ${past.title}\n${past.details}`);
                            }
                          }}
                          className="text-xs font-bold text-sky-600 hover:text-sky-700 hover:underline block text-left cursor-pointer"
                        >
                          {past.title}
                        </button>
                        {past.details && (
                          <p className="text-[11px] text-slate-600 line-clamp-2 leading-relaxed">
                            {past.details}
                          </p>
                        )}
                      </div>
                    ))
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : (
        /* ========================================================================= */
        /* 2. COMPLAINTS LIST VIEW / กล่องข้อความ (Images 2, 3) */
        /* ========================================================================= */
        <div className="p-6 space-y-5">
          {/* Top Bar matching Image 2 & 3 */}
          <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4">
            {/* Title & Back Button */}
            <div className="flex items-center gap-3">
              <button
                type="button"
                onClick={onBackToMenu}
                className="w-8 h-8 rounded-full border border-slate-300 hover:bg-slate-100 flex items-center justify-center text-slate-600 transition-colors cursor-pointer"
                title="กลับสู่เมนูหลัก"
              >
                <ChevronLeft className="w-5 h-5" />
              </button>
              <h1 className="text-xl font-bold text-slate-900">กล่องข้อความ</h1>
            </div>

            {/* Top Right Action Buttons matching Image 2 */}
            <div className="flex items-center gap-3">
              {/* Grey PRINT Button */}
              <button
                type="button"
                onClick={() => window.print()}
                className="px-4 py-2 bg-slate-300 hover:bg-slate-400 text-slate-800 rounded-md text-xs font-semibold flex items-center gap-1.5 transition-colors cursor-pointer"
              >
                <Printer className="w-3.5 h-3.5 text-slate-700" /> พิมพ์
              </button>

              {/* Blue SEND MESSAGE TO RESIDENT Button */}
              <button
                type="button"
                onClick={() => setShowNewMessageModal(true)}
                className="px-5 py-2 bg-blue-600 hover:bg-blue-700 text-white rounded-md text-xs font-bold flex items-center gap-1.5 shadow-xs transition-colors cursor-pointer"
              >
                <Plus className="w-4 h-4" /> ส่งข้อความถึงเจ้าของร่วม/สมาชิก
              </button>
            </div>
          </div>

          {/* Tabs: 'คำร้อง' vs 'เสร็จสิ้นแล้ว' matching Image 2 */}
          <div className="border-b border-slate-100 flex items-center gap-6 text-xs font-bold pt-1">
            <button
              type="button"
              onClick={() => setActiveTab('active')}
              className={`pb-2.5 transition-colors relative cursor-pointer ${
                activeTab === 'active'
                  ? 'text-sky-600 border-b-2 border-sky-600 font-black'
                  : 'text-slate-500 hover:text-slate-800'
              }`}
            >
              คำร้อง
              {complaints.filter((c) => c.status === 'active').length > 0 && (
                <span className="ml-1.5 px-1.5 py-0.2 rounded-full bg-rose-500 text-white text-[10px]">
                  {complaints.filter((c) => c.status === 'active').length}
                </span>
              )}
            </button>
            <button
              type="button"
              onClick={() => setActiveTab('completed')}
              className={`pb-2.5 transition-colors relative cursor-pointer ${
                activeTab === 'completed'
                  ? 'text-sky-600 border-b-2 border-sky-600 font-black'
                  : 'text-slate-500 hover:text-slate-800'
              }`}
            >
              เสร็จสิ้นแล้ว
            </button>
          </div>

          {/* Date Filter & Search Row matching Image 2 & 3 */}
          <div className="flex flex-col md:flex-row md:items-center justify-end gap-3 pt-1">
            {/* Date Range: เรียงดูตามวัน [ 29/02/2024 ] ถึง [ 29/03/2024 ] */}
            <div className="flex items-center gap-2 text-xs text-slate-600">
              <span>เรียงดูตามวัน</span>
              <div className="flex items-center border border-slate-300 rounded-md bg-white px-2 py-1 gap-1">
                <input
                  type="date"
                  value={startDate}
                  onChange={(e) => setStartDate(e.target.value)}
                  className="text-xs bg-transparent focus:outline-none text-slate-700"
                />
              </div>
              <span>ถึง</span>
              <div className="flex items-center border border-slate-300 rounded-md bg-white px-2 py-1 gap-1">
                <input
                  type="date"
                  value={endDate}
                  onChange={(e) => setEndDate(e.target.value)}
                  className="text-xs bg-transparent focus:outline-none text-slate-700"
                />
              </div>
            </div>

            {/* Search Input with Blue "ค้นหา" Button */}
            <div className="flex items-center">
              <input
                type="text"
                placeholder="ค้นหา"
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                className="w-48 sm:w-56 px-3 py-1.5 text-xs border border-slate-300 rounded-l-md focus:outline-none focus:ring-1 focus:ring-sky-500 bg-white"
              />
              <button
                type="button"
                className="px-4 py-1.5 bg-blue-600 hover:bg-blue-700 text-white text-xs font-bold rounded-r-md cursor-pointer transition-colors"
              >
                ค้นหา
              </button>
            </div>
          </div>

          {/* Complaints List Cards matching Images 2 & 3 */}
          <div className="space-y-3">
            {filteredComplaints.length === 0 ? (
              <div className="border border-slate-200 rounded-xl p-12 text-center text-slate-400 text-xs bg-slate-50/50 space-y-2">
                <MessageSquare className="w-8 h-8 mx-auto text-slate-300" />
                <p>ไม่พบรายการคำร้องเรียนตามเงื่อนไขที่เลือก</p>
              </div>
            ) : (
              filteredComplaints.map((item) => (
                <div
                  key={item.id}
                  className="border border-slate-200 rounded-lg p-4 bg-white shadow-2xs hover:border-slate-300 transition-all grid grid-cols-1 md:grid-cols-12 gap-3 items-center"
                >
                  {/* Left Column: Unit & Resident (Cols 3) */}
                  <div className="md:col-span-3 space-y-0.5">
                    <span className="text-sm font-bold text-slate-900 block font-sans">
                      {item.unitNo}
                    </span>
                    <span className="text-xs text-slate-500 block">{item.residentName}</span>
                  </div>

                  {/* Center Column: Blue Clickable Link Title (Cols 6) */}
                  <div className="md:col-span-6">
                    <button
                      type="button"
                      onClick={() => {
                        setSelectedComplaintId(item.id);
                        setShowCardMenu(false);
                      }}
                      className="text-xs font-bold text-sky-600 hover:text-sky-800 hover:underline text-left cursor-pointer transition-colors"
                    >
                      {item.title}
                    </button>
                  </div>

                  {/* Right Column: Date (Cols 3) */}
                  <div className="md:col-span-3 text-left md:text-right">
                    <span className="text-xs text-slate-500">{item.date}</span>
                  </div>
                </div>
              ))
            )}
          </div>
        </div>
      )}

      {/* ========================================================================= */}
      {/* 3. MODAL: + ส่งข้อความถึงเจ้าของร่วม/สมาชิก */}
      {/* ========================================================================= */}
      {showNewMessageModal && (
        <div className="fixed inset-0 z-50 bg-slate-900/40 backdrop-blur-xs flex items-center justify-center p-4">
          <div className="bg-white rounded-2xl border border-slate-200 shadow-2xl max-w-lg w-full overflow-hidden animate-in fade-in zoom-in-95 duration-150">
            {/* Header */}
            <div className="px-6 py-4 border-b border-slate-100 flex items-center justify-between bg-slate-50/50">
              <h3 className="text-sm font-bold text-slate-900 flex items-center gap-2">
                <Send className="w-4 h-4 text-blue-600" />
                ส่งข้อความถึงเจ้าของร่วม/สมาชิก
              </h3>
              <button
                type="button"
                onClick={() => setShowNewMessageModal(false)}
                className="text-slate-400 hover:text-slate-600 p-1 rounded-lg hover:bg-slate-100 cursor-pointer"
              >
                <X className="w-4 h-4" />
              </button>
            </div>

            {/* Form */}
            <form onSubmit={handleCreateNewMessage} className="p-6 space-y-4 text-xs">
              <div className="grid grid-cols-2 gap-3">
                <div>
                  <label className="block font-bold text-slate-700 mb-1">ยูนิต / บ้านเลขที่</label>
                  <select
                    value={newMsgUnit}
                    onChange={(e) => {
                      setNewMsgUnit(e.target.value);
                      if (e.target.value === '1086/20') setNewMsgRecipient('Silverman support');
                      else if (e.target.value === '1086/16') setNewMsgRecipient('tobb555 satob');
                      else setNewMsgRecipient('เจ้าของร่วม');
                    }}
                    className="w-full p-2 border border-slate-300 rounded-lg text-xs bg-white text-slate-800 focus:outline-none focus:ring-1 focus:ring-blue-500"
                  >
                    <option value="1086/20">1086/20</option>
                    <option value="1086/16">1086/16</option>
                    <option value="1086/01">1086/01</option>
                    <option value="1086/02">1086/02</option>
                    <option value="1086/08">1086/08</option>
                    <option value="1086/12">1086/12</option>
                  </select>
                </div>

                <div>
                  <label className="block font-bold text-slate-700 mb-1">ชื่อผู้รับ</label>
                  <input
                    type="text"
                    value={newMsgRecipient}
                    onChange={(e) => setNewMsgRecipient(e.target.value)}
                    className="w-full p-2 border border-slate-300 rounded-lg text-xs bg-white text-slate-800 focus:outline-none"
                    placeholder="ชื่อผู้รับ"
                  />
                </div>
              </div>

              <div>
                <label className="block font-bold text-slate-700 mb-1">หัวข้อเรื่อง *</label>
                <input
                  type="text"
                  value={newMsgTitle}
                  onChange={(e) => setNewMsgTitle(e.target.value)}
                  placeholder="เช่น สอบถามการชำระค่าส่วนกลาง, แจ้งนัดหมาย"
                  className="w-full p-2 border border-slate-300 rounded-lg text-xs bg-white text-slate-800 focus:outline-none"
                  required
                />
              </div>

              <div>
                <label className="block font-bold text-slate-700 mb-1">ข้อความ *</label>
                <textarea
                  rows={4}
                  value={newMsgBody}
                  onChange={(e) => setNewMsgBody(e.target.value)}
                  placeholder="พิมพ์ข้อความที่ต้องการติดต่อ..."
                  className="w-full p-2 border border-slate-300 rounded-lg text-xs bg-white text-slate-800 focus:outline-none"
                  required
                />
              </div>

              {/* Attach Image */}
              <div>
                <label className="block font-bold text-slate-700 mb-1">แนบรูปภาพ (ถ้ามี)</label>
                <div className="flex items-center gap-3">
                  <label className="px-3 py-1.5 border border-slate-300 rounded-lg bg-slate-50 hover:bg-slate-100 flex items-center gap-1.5 cursor-pointer text-slate-700 font-medium">
                    <ImageIcon className="w-3.5 h-3.5 text-slate-500" />
                    <span>เลือกไฟล์</span>
                    <input
                      type="file"
                      accept="image/*"
                      className="hidden"
                      onChange={(e) => {
                        const file = e.target.files?.[0];
                        if (file) setNewMsgImage(URL.createObjectURL(file));
                      }}
                    />
                  </label>
                  {newMsgImage && (
                    <span className="text-[11px] text-emerald-600 font-medium flex items-center gap-1">
                      <Check className="w-3.5 h-3.5" /> แนบรูปภาพแล้ว
                    </span>
                  )}
                </div>
              </div>

              {/* Actions */}
              <div className="flex items-center justify-end gap-2 pt-3 border-t border-slate-100">
                <button
                  type="button"
                  onClick={() => setShowNewMessageModal(false)}
                  className="px-4 py-2 rounded-lg bg-slate-100 hover:bg-slate-200 text-slate-700 font-medium cursor-pointer"
                >
                  ยกเลิก
                </button>
                <button
                  type="submit"
                  className="px-5 py-2 rounded-lg bg-blue-600 hover:bg-blue-700 text-white font-bold cursor-pointer shadow-xs"
                >
                  ส่งข้อความ
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};
